import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RecognizeByPage } from './recognize-by.page';

const routes: Routes = [
  {
    path: '',
    component: RecognizeByPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecognizeByPageRoutingModule {}
